module.exports = __webpack_public_path__ + "static/media/west-pharmaceuticals.5f885c2c.jpg";